import React, { Suspense, useState } from 'react'
import lazyWithRetry from '../../../utils/lazyWithRetry'
import DashboardAnalytics from './DashboardAnalytics'
import DashboardDeeperInsight from './DashboardDeeperInsight'
import DashboardSkeleton from './skeleton/DashboardSkeleton'
import '../../../styles/early/earlyMotion.css'

const WelcomeBackHeader = lazyWithRetry(() => import('./WelcomeBackHeader'), './WelcomeBackHeader')

const EarlyDashboard = () => {
    return (
        <div className="bg-[#ECEBF8] px-[40px] py-[40px] h-full flex justify-center items-center">
            <Suspense fallback={<DashboardSkeleton />}>
                <div className="grid grid-cols-12 gap-[30px] em-stagger em-stagger-rise">
                    <div className="col-span-5">
                        <WelcomeBackHeader />
                    </div>
                    <div className="col-span-4">
                        <DashboardAnalytics />
                    </div>
                    <div className="col-span-3">
                        <DashboardDeeperInsight />
                    </div>
                </div>
            </Suspense>
        </div>
    )
}

export default EarlyDashboard
